import { render, staticRenderFns } from "./OnboardingContact.vue?vue&type=template&id=2d058f34&"
import script from "./OnboardingContact.vue?vue&type=script&lang=js&"
export * from "./OnboardingContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports